<template>
	<div>
		<v-dialog v-model="dialog_move_addons" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow>Move AddOns Below</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height nopadding>

		        	<v-list two-line nopadding>

		        		<div v-for="(item, index) in addOnsMovableItems" :key="index" v-show="$parent.currentAddOnsIndex != index && $parent.currentAddOnsIndex-1 != index">

	        				<v-list-tile :ripple="true" @click="moveAddOns(item.type, index)">
			        			<v-list-tile-content>
			        			  <v-list-tile-title>{{item.name}}</v-list-tile-title>
			        			  <v-list-tile-sub-title>
			        			  	{{item.mode ? '&#8377;' : ''}} {{item.value}}{{!item.mode ? '%' : ''}}
			        			  </v-list-tile-sub-title>
			        			</v-list-tile-content>
			        		</v-list-tile>  	

			        		<v-divider></v-divider>

		        		</div>
		        		
		        	</v-list>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['addOnsMovableItems', 'moveAddOns'],
		data(){
			return{
				dialog_move_addons:false,
			}
		},
		methods:{
			openDialogWeb: function () {
				console.log(this.addOnsMovableItems);
				this.dialog_move_addons = true;
			},
			closeDialogWeb: function () {
				this.dialog_move_addons = false;
			},
			// fn_moveAddOns: function (index) {
			// 	this.$parent.fn_closeDialog();
			// 	let addOnsItem = JSON.parse(JSON.stringify(this.$parent.Form.transactionTypeAddOns[this.$parent.currentAddOnsIndex]));
			// 	this.$parent.Form.transactionTypeAddOns.splice(this.$parent.currentAddOnsIndex, 1)
			// 	this.$parent.Form.transactionTypeAddOns.splice(index, 0, addOnsItem);
			// }
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/transaction/dialog_move_addons.vue